














































import { Component, Prop, Vue } from 'vue-property-decorator'
import Modal from '@/app/ui/components/Modal/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'

@Component({
  components: {
    Modal,
    Button,
    TextInput
  },
})
export default class ModalInput extends Vue {
  // Modal visibility
  @Prop({ default: false }) private visible!: boolean

  // Modal content
  @Prop({ default: 'Alasan Tolak' }) private title!: string
  @Prop({ default: 'Berikan alasan penolakan terhadap jadwal ini.' }) private description!: string

  // Input props
  @Prop({ default: 'Alasan Tolak' }) private inputPlaceholder!: string
  @Prop({ default: 'textarea' }) private inputType!: string
  @Prop({ default: false }) private withCounter!: boolean
  @Prop({ default: 500 }) private maxCount!: number
  @Prop({ default: false }) private disabled!: boolean
  @Prop({ default: '' }) private inputCustomClass!: string
  @Prop({ default: '' }) private errorMessage!: string
  @Prop({ default: false }) private isInputError!: boolean

  // Button props
  @Prop({ default: 'Kembali' }) private btnCancelText!: string
  @Prop({ default: 'Lanjutkan' }) private btnConfirmText!: string

  // Validation
  @Prop({ default: false }) private required!: boolean
  @Prop({ default: 0 }) private minLength!: number

  // Initial value
  @Prop({ default: '' }) private value!: string

  inputValue = ''

  mounted() {
    this.inputValue = this.value
  }

  get isSubmitEnabled() {
    if (!this.required) return true
    if (this.minLength > 0) {
      return this.inputValue.trim().length >= this.minLength
    }
    return this.inputValue.trim().length > 0
  }

  onInputChange(value: string) {
    this.inputValue = value
    this.$emit('input', value)
  }

  onCancel() {
    this.$emit('cancel')
    this.resetInput()
  }

  onSubmit() {
    if (!this.isSubmitEnabled) return
    this.$emit('submit', this.inputValue)
    this.resetInput()
  }

  resetInput() {
    this.inputValue = ''
  }
}
